<form [formGroup]="formGroup">
  <div class="card">
    <div class="card-body">
      <!-- HEADER -->
      <div class="mb-3">
        <p class="h4 m-0">Informações Básicas do Evento</p>
        <p class="text-secondary">
          Dê um nome ao seu evento, escolha uma categoria, descrição e adicione um banner atraente.
        </p>
      </div>

      <!-- TITLE + CATEGORY -->
      <div class="row mb-3">
        <!-- TITLE -->
        <div class="col-sm-12 col-md-6 col-lg-8">
          <label for="title" class="form-label">Nome do Evento</label>
          <input
            id="title"
            type="text"
            formControlName="title"
            class="form-control"
            [class.is-invalid]="formGroup.controls.title.touched && formGroup.controls.title.invalid"
            placeholder="Digite o nome do evento" />

          @if (formGroup.controls.title.touched && formGroup.controls.title.invalid) {
            <div class="invalid-feedback">O nome do evento é obrigatório.</div>
          }
        </div>

        <!-- CATEGORY -->
        <div class="col-sm-12 col-md-6 col-lg-4">
          <label for="eventCategoryId" class="form-label">Categoria</label>
          <select
            id="eventCategoryId"
            formControlName="eventCategoryId"
            class="form-select"
            [class.is-invalid]="
              formGroup.controls.eventCategoryId.touched && formGroup.controls.eventCategoryId.invalid
            ">
            <option [ngValue]="null" disabled>Selecione uma categoria</option>

            @for (item of eventCategories; track item.id) {
              <option [ngValue]="item.id">{{ item.title }}</option>
            }
          </select>

          @if (formGroup.controls.eventCategoryId.touched && formGroup.controls.eventCategoryId.invalid) {
            <div class="invalid-feedback">Selecione uma categoria válida para o evento.</div>
          }
        </div>
      </div>

      <!-- DESCRIPTION -->
      <div class="mb-3">
        <label for="description" class="form-label">Descrição do Evento</label>
        <textarea
          id="description"
          rows="5"
          formControlName="description"
          class="form-control"
          [class.is-invalid]="formGroup.controls.description.touched && formGroup.controls.description.invalid"
          placeholder="Digite a descrição do evento"></textarea>

        @if (formGroup.controls.description.touched && formGroup.controls.description.invalid) {
          <div class="invalid-feedback">A descrição do evento é obrigatória.</div>
        }
      </div>

      <!-- MEDIA -->
      <div class="row" [formGroup]="mediaGroup">
        <!-- BANNER -->
        <div class="col-12 mb-4">
          <label for="uploadBanner" class="form-label">Banner Principal</label>

          @if (uploadedBannerPreview) {
            <div class="image-preview mb-2">
              <img [src]="uploadedBannerPreview" alt="Banner do evento" />

              <div class="d-flex gap-2 flex-wrap">
                <app-button icon="pi pi-pencil" type="button" (btnClick)="enableBannerChange()">
                  Alterar banner
                </app-button>

                <app-button icon="pi pi-trash" type="button" (btnClick)="clearBanner()"> Remover banner </app-button>
              </div>
            </div>
          }

          @if (showBannerInput) {
            <input
              #bannerInput
              id="uploadBanner"
              type="file"
              formControlName="uploadBanner"
              class="form-control"
              [class.is-invalid]="mediaGroup.controls.uploadBanner.touched && mediaGroup.controls.uploadBanner.invalid"
              (change)="onBannerFileChange($event)" />

            @if (mediaGroup.controls.uploadBanner.touched && mediaGroup.controls.uploadBanner.invalid) {
              <div class="invalid-feedback">O banner é obrigatório.</div>
            }
          }
        </div>

        <!-- MAP -->
        <div class="col-12">
          <label for="mapaEvento" class="form-label">Mapa do evento (opcional)</label>

          @if (uploadedMapPreview) {
            <div class="image-preview mb-2">
              <img [src]="uploadedMapPreview" alt="Mapa do evento" />

              <div class="d-flex gap-2 flex-wrap">
                <app-button icon="pi pi-pencil" type="button" (btnClick)="enableMapChange()"> Alterar mapa </app-button>

                <app-button icon="pi pi-trash" type="button" (btnClick)="clearMap()"> Remover mapa </app-button>
              </div>
            </div>
          }

          @if (showMapInput) {
            <input
              #mapInput
              id="mapaEvento"
              type="file"
              formControlName="mapaEvento"
              class="form-control"
              (change)="onMapFileChange($event)" />
          }
        </div>
      </div>
    </div>
  </div>
</form>
